<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <div class="card-title row">
            <div class="col-md-3">
              <div class="input-group">
                <label class="form-label">Reporte: </label> 
                <select 
                  v-model="filters.reporte" 
                  class="form-select"
                >
                  <option value="Valorado">Valorado</option>
                  <option value="ValoradoME">Valorado M.E.</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Gestion: </label>
                  <select 
                    v-model="filters.gestion" 
                    class="form-select"
                  >
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Ventanilla: </label>
                  <select v-model="filters.ventanilla" class="form-select">
                    <option value="">Todos</option>
                    <option v-for="ven in ventanillas" :key="ven.id" :value="ven.id">
                      {{ ven.nombre_completo }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="filters.reporte === 'Tramite'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Tipo Tramite: </label>
                  <select v-model="filters.tramite" class="form-select">
                    <option value="">Seleccione Tipo de Tramite</option>
                    <option 
                      v-for="tipotramite in tipotramites" 
                      :key="tipotramite.id" 
                      :value="tipotramite.id"
                    >
                      {{ tipotramite.tipo }} 
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3" style="margin: 0px; padding: 0px;">
            <div class="col-md-6" v-if="filters.reporte=='Economico'">
              <div class="form-group">
                <div class="input-group">
                  <lavel>Unidad:</lavel>
                  <select 
                    v-model="filters.id_unidad" 
                    class="form-select" 
                    @change="(e) => { console.log('Cambió unidad:', e.target.value); fetchAreas() }"
                  >
                    <option value="">Todas las unidades</option>
                    <option 
                      v-for="unidad in unidades" 
                      :key="unidad.id" 
                      :value="unidad.id"
                    >
                      {{ unidad.nombre_unidad }} ({{ unidad.codigo }})
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="filters.reporte=='Economico'">
              <div class="form-group">
                <div class="input-group">
                  <label>Area:</label>
                  <select 
                    v-model="filters.id_area" 
                    class="form-select"
                  >
                    <option value="">Todas las secciones</option>
                    <option 
                      v-for="area in areas" 
                      :key="area.id" 
                      :value="area.id"
                    >
                      ({{ area.codigo }}) {{ area.nombre_area }} 
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Tipo: </label>
                  <select v-model="filters.tipo" class="form-select">
                    <option value="">Fechas</option>
                    <option value="Diario">Diario</option>
                    <option value="Mensual">Mensual</option>
                    <option value="Anual">Anual</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2" v-if="showMes">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Mes: </label>
                  <select v-model="filters.mes" class="form-select">
                    <option value="0">Todos los meses</option>
                    <option v-for="mes in meses" :key="mes.valor" :value="mes.valor">
                      {{ mes.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Filtro de Fecha (solo para Diario) -->
            <div class="col-md-3" v-if="showFecha">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Fecha: </label>
                  <input
                    type="date"
                    v-model="filters.fecha"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-3" v-if="showDesdeHasta">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">De: </label>
                  <input
                    type="date"
                    v-model="filters.desde"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3" v-if="showDesdeHasta">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label"> A: </label>
                  <input
                    type="date"
                    v-model="filters.hasta"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            
            <div class="col-md-3 d-flex align-items-center">
              
              <BButton 
                    class="btn btn-sm btn-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </BButton>
              <BButton
                variant="danger"
                class="btn btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>

        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                <thead class="text-primary">
                  <tr style="line-height: 8px;">
                    <th>Item</th>
                    <th>Descripcion del Valor</th>
                    <th>Del_Nro.</th>
                    <th>Al_Nro.</th>
                    <th>Cantidad</th>
                    <th>P.U.</th>
                    <th>Total_Bs</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tramite, index) in tramites" :key="tramite.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ tramite.descripcion }}</td>
                    <td>{{ tramite.desde }}</td>
                    <td>{{ tramite.hasta }}</td>
                    <td>{{ tramite.cantidad }}</td>
                    <td>{{ tramite.costo }}</td>
                    <td>{{ (tramite.costo * tramite.cantidad) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Tramite {
  id: number;
  id_tipo_tramite: number;
  id_solicitante: number;
  gestion: number;
  codigo: string;
}

interface Filters {
  id_unidad: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const showMes = computed(() => filters.value.tipo === 'Mensual');
    const showFecha = computed(() => filters.value.tipo === 'Diario');
    const showDesdeHasta = computed(() => !filters.value.tipo || filters.value.tipo === '');

    const tramites = ref<Tramite[]>([]);
    const loading = ref(true);
    const ventanillas = ref([]);
    const authStore = useAuthStore();
    const fechaActual = new Date();
    const filters = ref<Filters>({
      reporte:'Valorado',
      ventanilla: '',
      tipotramite:'',
      gestion: ref(new Date().getFullYear()),
      desde: new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1).toISOString().split('T')[0],
      hasta: new Date().toISOString().split('T')[0],
      fecha: new Date().toISOString().split('T')[0],
      tipo:'',
      tramite: '',
      mes: new Date().getMonth() + 1,
      informar: false
    });
    const meses = [
      { valor: 1, nombre: 'Enero' },
      { valor: 2, nombre: 'Febrero' },
      { valor: 3, nombre: 'Marzo' },
      { valor: 4, nombre: 'Abril' },
      { valor: 5, nombre: 'Mayo' },
      { valor: 6, nombre: 'Junio' },
      { valor: 7, nombre: 'Julio' },
      { valor: 8, nombre: 'Agosto' },
      { valor: 9, nombre: 'Septiembre' },
      { valor: 10, nombre: 'Octubre' },
      { valor: 11, nombre: 'Noviembre' },
      { valor: 12, nombre: 'Diciembre' },
    ];
    const errors = ref<Record<string, string[]>>({});
    
    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const handleTipoChange = () => {
      // Resetear filtros cuando cambia el tipo
      if (filters.value.tipo === 'Diario') {
        filters.value.fecha = new Date().toISOString().split('T')[0];
        filters.value.mes = 0;
        filters.value.desde = '';
        filters.value.hasta = '';
      } else if (filters.value.tipo === 'Mensual') {
        filters.value.fecha = '';
        filters.value.desde = '';
        filters.value.hasta = '';
        filters.value.mes = new Date().getMonth() + 1;
      } else if (filters.value.tipo === 'Anual') {
        filters.value.fecha = '';
        filters.value.mes = 0;
        filters.value.desde = '';
        filters.value.hasta = '';
      } else {
        filters.value.fecha = '';
        filters.value.mes = 0;
      }
    };

    const fetchVentanillas = async () => {
      try {
        const response = await axios.get('/tipotramite/selectventanilla');
        ventanillas.value = response.data.ventanilla || [];
      } catch (error) {
        console.error('Error al cargar ventanillas:', error);
      }
    };
    const fetchTramite = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        if (filters.value.reporte) {
          params.reporte = filters.value.reporte;
        }
        if (filters.value.ventanilla) {
          params.ventanilla = filters.value.ventanilla;
        }
        if (filters.value.gestion) {
          params.gestion = filters.value.gestion;
        }
        if (filters.value.tipo) {
          params.tipo = filters.value.tipo;
        }
        
        if (filters.value.tipo === 'Diario' && filters.value.fecha) {
          params.fecha = filters.value.fecha;
        } else if (filters.value.tipo === 'Mensual' && filters.value.mes) {
          params.mes = filters.value.mes;
        } else if (!filters.value.tipo || filters.value.tipo === '') {
          if (filters.value.desde) params.desde = filters.value.desde;
          if (filters.value.hasta) params.hasta = filters.value.hasta;
        }
        
        const response = await axios.get('/reportes/valorados', { params });
        tramites.value = response.data.datos.data || response.data.datos;
        
        // Actualizar paginación si la API la soporta
        if (response.data.datos.meta) {
          pagination.value = {
            current_page: response.data.datos.meta.current_page,
            per_page: response.data.datos.meta.per_page,
            total: response.data.datos.meta.total,
            last_page: response.data.datos.meta.last_page
          };
        }
      } catch (error) {
        console.error('Error al cargar tramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tramites'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchTramite();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchTramite();
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      //const params = filters.value.id_unidad ? { id_unidad: filters.value.id_unidad } : {};
      const params = {
        ...(filters.value.reporte && { reporte: filters.value.reporte }),
        ...(filters.value.ventanilla && { ventanilla: filters.value.ventanilla }),
        ...(filters.value.gestion && { gestion: filters.value.gestion }),
        ...(filters.value.tipo && { tipo: filters.value.tipo }),
        ...(filters.value.tramite && { tramite: filters.value.tramite }),
      };
      
      if (filters.value.tipo === 'Diario' && filters.value.fecha) {
        params.fecha = filters.value.fecha;
      } else if (filters.value.tipo === 'Mensual' && filters.value.mes) {
        params.mes = filters.value.mes;
      } else if (!filters.value.tipo || filters.value.tipo === '') {
        if (filters.value.desde) params.desde = filters.value.desde;
        if (filters.value.hasta) params.hasta = filters.value.hasta;
      }

      axios.get('/reportes/valoradopdf', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-economico.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchTramite();
      fetchVentanillas();
    });
    
    return {
      meses,
      tramites,
      ventanillas,
      filters,
      loading,
      errors,
      pagination,
      handleSearch,
      handlePageChange,
      hasPermission,
      generatePDF,
      showMes,
      showFecha,
      showDesdeHasta,
      handleTipoChange
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
  .search-results {
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 10px;
  }

  .search-result-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }

  .search-result-item:hover {
    background-color: #f5f5f5;
  }

  .search-result-item.selected {
    background-color: #e9f7fe;
    font-weight: bold;
  }

  .selected-persona {
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-top: 8px;
  }
</style>